import React, {useContext, useEffect} from "react"
import {RouteDetailContext} from "./context/RouteDetailContext";
import Column from "@amzn/meridian/column";
import Tab, {TabGroup} from "@amzn/meridian/tab";
import {FormattedMessage} from "react-intl";

const PicklistSelector = () => {
    const {viewModelRD, dispatchRD} = useContext(RouteDetailContext)

    const changePicklist = (newPicklist) => {
        dispatchRD({type: 'CHANGE_PICKLIST', data: {selectedPicklist: newPicklist}})
    }

    useEffect(() => {
        if (!viewModelRD.selectedPicklist) {
            changePicklist(viewModelRD.picklists[0].picklistId)
        }
    }, []);

    return (
        <Column>
            <TabGroup value={viewModelRD.selectedPicklist} onChange={changePicklist}>
                {viewModelRD.picklists.map((picklist, index) =>
                    <Tab key={picklist.picklistId} value={picklist.picklistId}>
                        <FormattedMessage id="routeInfo.picklist" defaultMessage="Picklist"/>
                        {index + 1} ({picklist.picklistCode})
                    </Tab>
                )}
            </TabGroup>
        </Column>

    )
}

export default PicklistSelector


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/PicklistSelector.js